import { can } from '@kia/shared';
import { useAuth } from '../auth/AuthProvider';
import { AiChatScreen } from './AiChatScreen';
import { ExportPanel } from './ExportScreen';

/**
 * «دستیار تحلیل» — the analysis surface: the AI chat (self-gated to `ai.use`) plus the
 * export/briefing panel (visible to every role, so non-admins keep their export access). Data entry
 * lives on its own «ثبت هوشمند» tab now, so there is no mode switch here anymore.
 */
export function AnalysisScreen({
  onOpenDeal,
  seed,
  onSeedConsumed,
}: {
  onOpenDeal?: ((id: number) => void) | undefined;
  /** AI-3: a deal→analyst deep-link question to pre-fill the chat composer, forwarded to AiChatScreen. */
  seed?: string | undefined;
  onSeedConsumed?: (() => void) | undefined;
}) {
  const { user } = useAuth();
  const canAi = user ? can(user.role, 'ai.use') : false;
  return (
    <>
      {canAi ? (
        <AiChatScreen onOpenDeal={onOpenDeal} seed={seed} onSeedConsumed={onSeedConsumed} />
      ) : null}
      <ExportPanel />
    </>
  );
}
